import styled from '@emotion/styled';
import { Breadcrumb, Divider, Image, Space } from 'antd';
import { FaHome } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../routes';
import { ORANGE, YELLOW } from '../../../shared/colors';
import { Footer } from '../../homePage/components/Footer';
import { Layout } from '../../shared/Layout';
import { SubmenuFormation } from '../components/Submenu';

const Container = styled.div`
  // height: calc(100vh - 32px);
  background-color: white;

  .banner {
    height: 300px;
    background-color: white;
    background-image: url('/assets/images/formation-banner.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 5% 15% 5% 15%;

    .bread-crumb {
      font-size: 14px;
      margin-top: 10px;

      span {
        color: white;
        font-family: Poppins-L;
      }
    }

    .link {
      text-decoration: underline;
      cursor: pointer;
    }

    .menus {
      display: flex;

      > p {
        text-transform: uppercase;
        font-family: Poppins-L;
        font-size: 14px;
        padding: 13px 10px;
        margin-right: 15px;

        &:hover {
          background-color: ${YELLOW};
          cursor: pointer;
        }
      }

      .active {
        background-color: ${YELLOW};
      }
    }
  }

  > .content {
    min-height: 400px;
    background-color: white;
    color: black;
    padding: 2% 15%;

    > h2 {
      font-family: Poppins-B;
      font-size: 25px;
      margin-bottom: 15px;
    }

    > div {
      display: flex;
      flex-wrap: wrap;
      // background-color: green;
    }
  }
`;

export const MoranjePage = () => {
  const history = useHistory();

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <Space size={10}>
            <Image
              alt='moranje-logo'
              src='assets/images/moranje-logo.png'
              // height={250}
              width={130}
              preview={false}
              style={{ objectFit: 'contain', cursor: 'pointer' }}
            />
            <div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 35,
                }}
              >
                <span style={{ color: ORANGE }}>Moranj</span>
                <span style={{ color: '#6d4c41' }}>E</span>
                <span style={{ color: YELLOW }}>trade</span>
              </div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 30,
                }}
              >
                Formation
              </div>
            </div>
          </Space>
          <Breadcrumb separator='>' className='bread-crumb'>
            <Breadcrumb.Item>
              <FaHome style={{ marginRight: 5 }} />
              <span>Accueil</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item
              onClick={() => history.push(ROUTES.FORMATION.PAGE)}
            >
              <span className='link'>Formation</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>MoranjEtrade</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

          <div className='menus'>
            {SubmenuFormation('4').map((form, i) => (
              <p
                className={form.color ? 'active' : ''}
                key={i}
                onClick={() => history.push(form.link)}
              >
                {form.label}
              </p>
            ))}
          </div>
        </div>

        <div className='content'>
          <h2>MoranjEtrade Terminal</h2>

          <p> ...</p>
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};
